export default __webpack_public_path__ + "static/logo-leclerc-3fdb029688c74f101730590a5c5929a3.png";